module.exports = __webpack_public_path__ + "img/ring_g_i_null_0@3x.e11e095a.png";